export default "__VITE_ASSET__CR30GF_k__"